

export default function tryConvertToNumber (val) {
  const num = Number(val);
  if (Number.isNaN(num)) {
    return val;
  }
  return num;
}
